// eslint-disable-next-line import/prefer-default-export
export enum EConsultantNewArticleType {
  ARTICLE = 'text',
  PODCAST = 'podcast',
  VIDEO = 'video',
}
